import React from 'react';
import { Bar, BarChart, CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis, } from 'recharts';
import { CHART_INK, seriesColor } from './palette';
import { formatChartDay, formatCompact } from './format';
const axisTick = { fontSize: 11, fill: CHART_INK.muted };
/**
 * Daily time-series chart (line for trends, grouped thin bars for in-vs-out).
 * One y-axis only; hairline grid; legend whenever ≥ 2 series; hover tooltip
 * always on (dataviz interaction spec).
 */
export const DailySeriesChart = ({ data, series, xKey = 'day', kind = 'line', height = 240, valueFormatter = (n) => String(n), }) => {
    const common = {
        data,
        margin: { top: 8, right: 8, bottom: 0, left: 0 },
    };
    const grid = React.createElement(CartesianGrid, { stroke: CHART_INK.grid, strokeWidth: 1, vertical: false });
    const xAxis = (React.createElement(XAxis, { dataKey: xKey, tick: axisTick, tickFormatter: formatChartDay, axisLine: { stroke: CHART_INK.baseline }, tickLine: false, minTickGap: 24 }));
    const yAxis = (React.createElement(YAxis, { tick: axisTick, tickFormatter: formatCompact, axisLine: false, tickLine: false, width: 48 }));
    const tooltip = (React.createElement(Tooltip, { formatter: (v, name) => [valueFormatter(Number(v)), name], labelFormatter: (day) => formatChartDay(String(day)), contentStyle: {
            borderRadius: 8,
            border: `1px solid ${CHART_INK.grid}`,
            fontSize: 12,
        }, cursor: kind === 'bar' ? { fill: 'rgba(0,0,0,0.04)' } : { stroke: CHART_INK.baseline } }));
    const legend = series.length >= 2 ? React.createElement(Legend, { wrapperStyle: { fontSize: 12 }, iconType: "circle", iconSize: 8 }) : null;
    return (React.createElement(ResponsiveContainer, { width: "100%", height: height }, kind === 'bar' ? (React.createElement(BarChart, { ...common, barGap: 2, barCategoryGap: "24%" },
        grid,
        xAxis,
        yAxis,
        tooltip,
        legend,
        series.map((s, i) => (React.createElement(Bar, { key: s.key, dataKey: s.key, name: s.label, fill: seriesColor(i, s.color), radius: [4, 4, 0, 0], maxBarSize: 28, isAnimationActive: false }))))) : (React.createElement(LineChart, { ...common },
        grid,
        xAxis,
        yAxis,
        tooltip,
        legend,
        series.map((s, i) => (React.createElement(Line, { key: s.key, dataKey: s.key, name: s.label, stroke: seriesColor(i, s.color), strokeWidth: 2, dot: false, activeDot: { r: 4, strokeWidth: 2, stroke: '#ffffff' }, isAnimationActive: false })))))));
};
export default DailySeriesChart;
